import { getEnvironment, getGeography } from '@access-evo/evo-api';

/**
 * ChatOBI settings are geography-independent (one global deployment per
 * environment), so the same env map is reused for every geography. Values are
 * the ones previously supplied as REACT_APP_* build variables from the
 * chatobi-qna-frontend-uat / chatobi-qna-frontend-prod variable groups in
 * Azure DevOps Pipelines -> Library.
 */
const CHATBOT_BASE_URL = {
  dev: 'https://chatobiv2fe-uat.staah.net',
  preprod: 'https://chatobiv2fe-uat.staah.net',
  prod: 'https://hotelbotv2.staah.net',
};

const MFE_REGISTRY_BASE = {
  dev: '',
  preprod: '',
  prod: '',
};

const FEATURE_FEEDBACK_API_HOST = {
  dev: '',
  preprod: '',
  prod: '',
};

const FEATURE_FEEDBACK_ACCOUNT_TOKEN = {
  dev: '',
  preprod: '',
  prod: '',
};

const FEATURE_FEEDBACK_PRODUCT_NAME = {
  dev: 'chatobi',
  preprod: 'chatobi',
  prod: 'chatobi',
};

const SETTINGS = {
  graphApiUrl: {
    uk: {
      dev: 'https://preprodws.accessacloud.com/api/v2/graphql',
      preprod: 'https://preprodws.accessacloud.com/api/v2/graphql',
      prod: 'https://ws.accessacloud.com/api/v2/graphql',
    },
    us: {
      dev: 'https://preprodws.accessacloud.com/api/v2/graphql',
      preprod: 'https://preprodws.accessacloud.com/api/v2/graphql',
      prod: 'https://api.us.access-evo.com/prod/directory/graphql/v1',
    },
    au: {
      dev: 'https://preprodws.accessacloud.com/api/v2/graphql',
      preprod: 'https://preprodws.accessacloud.com/api/v2/graphql',
      prod: 'https://ws.access-workspace.com.au/api/v2/graphql',
    },
    eu: {
      dev: 'https://preprodws.accessacloud.com/api/v2/graphql',
      preprod: 'https://preprodws.accessacloud.com/api/v2/graphql',
      prod: 'https://api.eu.access-evo.com/prod/directory/graphql/v1',
    },
  },
  // Host of the guest widget bundle (hotel-chatbot.iife.js) used by the live
  // preview and the embed snippet.
  chatbotBaseUrl: {
    uk: CHATBOT_BASE_URL,
    us: CHATBOT_BASE_URL,
    au: CHATBOT_BASE_URL,
    eu: CHATBOT_BASE_URL,
  },
  // OpenComponents registry that serves the shared Feature Feedback component.
  mfeRegistryBase: {
    uk: MFE_REGISTRY_BASE,
    us: MFE_REGISTRY_BASE,
    au: MFE_REGISTRY_BASE,
    eu: MFE_REGISTRY_BASE,
  },
  featureFeedbackApiHost: {
    uk: FEATURE_FEEDBACK_API_HOST,
    us: FEATURE_FEEDBACK_API_HOST,
    au: FEATURE_FEEDBACK_API_HOST,
    eu: FEATURE_FEEDBACK_API_HOST,
  },
  featureFeedbackAccountToken: {
    uk: FEATURE_FEEDBACK_ACCOUNT_TOKEN,
    us: FEATURE_FEEDBACK_ACCOUNT_TOKEN,
    au: FEATURE_FEEDBACK_ACCOUNT_TOKEN,
    eu: FEATURE_FEEDBACK_ACCOUNT_TOKEN,
  },
  featureFeedbackProductName: {
    uk: FEATURE_FEEDBACK_PRODUCT_NAME,
    us: FEATURE_FEEDBACK_PRODUCT_NAME,
    au: FEATURE_FEEDBACK_PRODUCT_NAME,
    eu: FEATURE_FEEDBACK_PRODUCT_NAME,
  },
};

export type Settings = {
  graphApiUrl: string;
  chatbotBaseUrl: string;
  mfeRegistryBase: string;
  featureFeedbackApiHost: string;
  featureFeedbackAccountToken: string;
  featureFeedbackProductName: string;
};

export function getSetting(name: keyof Settings) {
  const environment = getEnvironment();
  const geography = getGeography();
  const envKey = environment === 'prod' || environment === 'preprod' ? environment : 'dev';
  return SETTINGS[name][geography][envKey];
}
